import CurrentRoom from './CurrentRoom';

export default CurrentRoom;
